import { parseSearchWith, stringifySearchWith } from '@tanstack/react-router';
import { parse as jsurlParse, stringify as jsurlStringify } from 'jsurl2';

/**
 * 検索パラメータの serializer。
 *
 * jsurl2 は `_` を空白へ復号するため、全値を通すと base64url の OAuth2 challenge 等の
 * opaque 文字列が parse で壊れる。jsurl2 は全値に終端子 `~` を付けるので、parse は
 * 末尾が `~` の値だけ復元し、opaque 文字列はそのまま通す。
 */
const parseValue = (value: string): unknown =>
  value.endsWith('~') ? jsurlParse(value) : value;

export const parseSearch = parseSearchWith(parseValue);

// 第2引数 jsurlParse: 文字列も jsurl2 で encode させ型を保持（無いと "123"→数値 123 に化ける）
export const stringifySearch = stringifySearchWith(
  (value) => jsurlStringify(value, { rich: true }),
  jsurlParse,
);
